/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailConfiguration
 */
export interface EmailConfiguration {
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    type: EmailConfigurationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    graph_token?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfiguration
     */
    clinic_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmailConfiguration
     */
    enabled?: boolean;
}


/**
 * @export
 */
export const EmailConfigurationTypeEnum = {
    Helpdesk: 'helpdesk',
    Transactional: 'transactional',
    Results: 'results'
} as const;
export type EmailConfigurationTypeEnum = typeof EmailConfigurationTypeEnum[keyof typeof EmailConfigurationTypeEnum];


/**
 * Check if a given object implements the EmailConfiguration interface.
 */
export function instanceOfEmailConfiguration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function EmailConfigurationFromJSON(json: any): EmailConfiguration {
    return EmailConfigurationFromJSONTyped(json, false);
}

export function EmailConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': json['type'],
        'email': json['email'],
        'graph_token': !exists(json, 'graph_token') ? undefined : json['graph_token'],
        'clinic_id': !exists(json, 'clinic_id') ? undefined : json['clinic_id'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function EmailConfigurationToJSON(value?: EmailConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'name': value.name,
        'type': value.type,
        'email': value.email,
        'graph_token': value.graph_token,
        'clinic_id': value.clinic_id,
        'enabled': value.enabled,
    };
}

